import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'countries',
  initialState: {
    countries: [],
    selected: [],
    centers: [],
    selectedCenters: [],
    apply: new Date(),
    firstLoad: true,
  },
  reducers: {
    setCountries: (state, { payload: obj }) => {
      state.countries = obj;
    },
  },
});

export const { setCountries } = slice.actions;

export default slice.reducer;

export const selectCountries = (state) => state.countries.countries;
